import { useFormikContext } from 'formik'
import { useState } from 'react'

import { DisconnectAccountModal, StepAccountAssociations, HelperWrapper } from 'src/components'
import { useStepAccountsConnectionsSelection } from 'src/hooks'

import { IStepForm, IStepFormSelectedAccount } from 'src/types'

interface IProps {
  isDisabled?: boolean
}

const AccountsAssociationInput = ({ isDisabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<IStepForm>()
  const [openRemoveConfirmation, setOpenRemoveConfirmation] = useState(false)
  const setSelectedAccounts = (val: IStepFormSelectedAccount | null) =>
    setFieldValue('selectedAccount', val)

  const handleRemoveConfirmation = () => {
    setOpenRemoveConfirmation(true)
  }

  const { handleSelectedAccount, selectedAccountsConnections, handleSelectedAccountShow } =
    useStepAccountsConnectionsSelection({
      selectedAccount: values.selectedAccount,
      setSelectedAccount: setSelectedAccounts,
      handleRemoveConfirmation,
    })

  const handleDelete = () => {
    setOpenRemoveConfirmation(false)
    setSelectedAccounts(null)
  }

  const handleClose = () => {
    setOpenRemoveConfirmation(false)
  }

  return (
    <>
      <StepAccountAssociations
        isDisabled={isDisabled}
        handleToggleSwitchItem={handleSelectedAccountShow}
        description={<HelperWrapper t="accounts-association-title" isColorInherited size={12} />}
        selectedItem={values.selectedAccount}
        handleSelectItem={handleSelectedAccount}
        connections={selectedAccountsConnections}
      />
      <DisconnectAccountModal
        open={openRemoveConfirmation}
        handleClose={handleClose}
        handleDelete={handleDelete}
      />
    </>
  )
}

export { AccountsAssociationInput }
